import {
  AvatarCustomer,
  ListItem,
  ListItemAvatar,
  ListItemLink,
  ListItemProps,
  ListItemText,
  Skeleton,
} from '@razz-team/ui-web';
import { ApiMember } from '../../../../openapi';
import { getMemberDisplayName } from './utils';

export interface MemberListItemProps extends ListItemProps {
  member: ApiMember | undefined;
  loading?: boolean;
  link?: boolean;
}

export function MemberListItem({ member, loading, link, ...props }: MemberListItemProps) {
  const name = getMemberDisplayName(member);
  const email = member?.identity.email ?? member?.identity.unconfirmedEmail;
  const role = member?.membership.role;

  const content = (
    <>
      <ListItemAvatar>
        <AvatarCustomer customer={member?.customer} />
      </ListItemAvatar>
      <ListItemText
        primary={loading ? <Skeleton /> : name ? `${name} • ${role}` : role}
        secondary={loading ? <Skeleton /> : (email ?? undefined)}
      />
    </>
  );

  return (
    <ListItem disablePadding={Boolean(link && member)} {...props}>
      {link && member ? (
        <ListItemLink to="/account/members/$customerId" params={{ customerId: member.customer.id }}>
          {content}
        </ListItemLink>
      ) : (
        content
      )}
    </ListItem>
  );
}
